// Vendors
import styled from 'styled-components';
// Utilities
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const EntrypointComponentStyled = styled.main`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    gap: 0;
    min-height: 100vh;
    height: auto;
  }
`;
EntrypointComponentStyled.displayName = 'EntrypointComponentStyled';

const EntrypointContentComponentStyled = styled.div<{ paddingContent?: boolean }>`
  background-color: ${({ theme }) => theme.color_neutral_screen_bg_175};
  border-radius: ${({ theme }) => theme.radius_150};
  height: auto;
  max-width: ${convertPxsToRems({ pixels: 1200, base: 14 })};
  padding: 0 ${({ theme }) => theme.spacing_300};
  margin: 0 auto;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    ${({ paddingContent }) =>
      paddingContent &&
      `
      align-items: stretch;
      display: flex;
      flex: 1;
      justify-content: center;
    `}
    max-width: 100%;
    padding: 0 ${({ paddingContent, theme }) => (paddingContent ? theme.spacing_300 : '0')}
      ${({ theme }) => theme.spacing_300};
  }
`;
EntrypointContentComponentStyled.displayName = 'EntrypointContentComponentStyled';

export { EntrypointComponentStyled, EntrypointContentComponentStyled };
